// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export const diagnosticLevelFromEnv: string | undefined = undefined;
